export default "/_next/static/images/service-dfa-desktop-3x-f1a1c6337207afbe41b966224b903064.jpg";